import React from 'react';

interface IProps {
  children: React.ReactNode | string;
}

const StepGuide = ({ children }: IProps) => {
  return (
    <div className='relative box-border inline-flex w-full items-center px-[18px] py-2 [&_span]:font-medium'>
      <div className='mr-[10px] h-[7px] w-[7px] rounded-full bg-[#039BE5]'></div>
      <p className='text-text-secondary mb-0! text-[15px] font-normal'>{children}</p>
    </div>
  );
};

export default React.memo(StepGuide);
